import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "../../../../../base/app/appModel";
import {
    IAccountReceivableDetail,
    IAccountReceivableFields, IAccountReceivableSearch, IAccountReceivableSearchParam,
} from "../../../../AccountTypes";
import { accountService } from "../../../../AccountService";
import { useDetailModel } from "../detailModel";
import { useGlobalModel } from "@/model/globalModel";
import { globalPrompt } from "@/components/YhMessage";
import { message } from "antd";
import { convertRes2Blob } from "@/utils/exportFile";

export const useReceivableModel = createModel(function () {
    const initSearchParam: IAccountReceivableSearchParam = {};
    const initDataSource: IAccountReceivableDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const { user: { shopCode, userName } } = useGlobalModel();
    const { customerCode } = useDetailModel();

    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountReceivableSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountReceivableDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountReceivableDetail>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    // 充值总额
    const [receivableAmount, setReceivableAmount] = useState<number>(0)
    const [approvalDrawerVisible, setApprovalDrawerVisible] = useState(false);
    const [loading, setLoading] = useState(false)
    const [exportLoading, setExportLoading] = useState(false)

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAccountReceivableFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {})
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAccountReceivableSearchParam = searchParam) => {
        try {
            setLoading(true)
            const searchParams: IAccountReceivableSearch = {
                // ...searchValue,
                // statusList: searchValue.statusList as any ?? "0,1,8",
                partnerCodes: customerCode,
                shopCode,
                page: {
                    pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                    pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
                }
            }
            let { retData } = await accountService.receivablePage(searchParams);
            let { retData: totalRetData } = await accountService.customerSummaryAll({partnerCodes: customerCode, shopCode})
            const { records, ...pg } = retData;
            let amount: number = 0
            totalRetData.forEach(i => {
                amount += i.totalDebtAmount??0
            })
            setReceivableAmount(amount)
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
            clearSelectData();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }


    //充值记录导出
    const billCustomerExport = async () => {
        setExportLoading(true)
        try {
        const searchParams: IAccountReceivableSearch = {
            // ...searchParam,
            partnerCodes: customerCode,
            shopCode,
        }
        let result = await accountService.receivableExport(searchParams);
        convertRes2Blob(result);            
        setExportLoading(false)
    } catch (error) {
        setExportLoading(false)
    }
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        receivableAmount,
        approvalDrawerVisible,
        loading,
        exportLoading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        onSearch,
        onReset,
        setSelectedData,
        setApprovalDrawerVisible,
        // onRevocation,
        billCustomerExport
    }
});
